exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.flickity-button-icon {\n  fill: white !important;\n}\n@media (max-width: 575.98px) {\n.auctionTitle {\n    margin-bottom: 0 !important;\n}\n.mobileAuctionTitle {\n    font-size: 1.2rem !important;\n}\n.nav-auction-logged-calendar .btnMobile {\n    font-size: 0.5rem !important;\n    margin-right: 0.4rem !important;\n}\n}\n\n/* purgecss end ignore */\n\n", ""]);

// exports
